import { FC } from 'react';

import { useAuth } from '@shared/state/hooks/useAuth';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import GiftSellerAuthRouter from './GiftSellerAuthRouter';

// TODO: 실제 로그인 페이지로 교체 필요
const GiftSellerLoginPage: FC = () => {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold">답례품 판매자 로그인</h1>
        <p className="mt-2 text-gray-500">로그인 페이지입니다.</p>
      </div>
    </div>
  );
};

export const GiftSellerRouter: FC = function GiftSellerRouter() {
  const { isStoreSeller, isAdmin } = useAuth();
  const { pathname, search } = useLocation();
  const isSellerAuthenticated = isStoreSeller() || isAdmin();

  if (
    pathname !== '/gift-seller/login' &&
    pathname !== '/gift-seller' &&
    pathname !== '/signup/init' &&
    !isSellerAuthenticated
  ) {
    sessionStorage.setItem('redirectUrlAfterGiftSellerLogin', pathname + search);
  }

  return (
    <div className="bg-white">
      <Routes>
        {/* logout required */}
        <Route
          path="login"
          element={
            !isSellerAuthenticated ? (
              <GiftSellerLoginPage />
            ) : (
              <Navigate to="/gift-seller" />
            )
          }
        />

        {/* login required */}
        <Route path="*" element={<GiftSellerAuthRouter />} />
      </Routes>
    </div>
  );
};
